import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=67e9642f&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e9642f')) {
      api.createRecord('67e9642f', component.options)
    } else {
      api.reload('67e9642f', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=67e9642f&", function () {
      api.rerender('67e9642f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b8DZu5Fk4WE6/JS/comp/FavElement.vue"
export default component.exports